/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip, TextField, InputAdornment } from '@mui/material'
import React, { useState } from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch'
import SearchIcon from '@mui/icons-material/Search';
import Data from './Data';
import ProductivityData from './ProductivityData';
import TimeData from './TimeData';
const AchievementPage = () => {

    const [activeTab, setActiveTab] = useState('default');

    const tabBtnStyle = {
        fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
    }
    return (
        <>
            <Box sx={{
                overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                maxWidth: '100%',
            }}>
                {/* Tabs */}
                <Box display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}>
                    <Button onClick={() => setActiveTab('default')} variant="contained" sx={{
                        ...tabBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'default' ? '#0076FE' : '#fff', color: activeTab === 'default' ? '#fff' : '#64748B', border: activeTab === 'default' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Efficiency pro
                    </Button>
                    <Button onClick={() => setActiveTab('complete')} variant="contained" sx={{
                        ...tabBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'complete' ? '#0076FE' : '#fff',
                        color: activeTab === 'complete' ? '#fff' : '#64748B', border: activeTab === 'complete' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>
                        Productivity champ
                    </Button>
                    <Button onClick={() => setActiveTab('timetabclick')} variant="contained" sx={{
                        ...tabBtnStyle,
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'timetabclick' ? '#0076FE' : '#fff',
                        color: activeTab === 'timetabclick' ? '#fff' : '#64748B', border: activeTab === 'timetabclick' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>
                        Time hero
                    </Button>
                </Box>
                {/* Tab Panel Content */}
            </Box>

            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="default">
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                    Efficiency pro
                                    <Tooltip title="Achievement badges are sent to members via email and appear on their dashboard." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Earn this badge daily by hitting your activity target. Rack up consecutive wins to build impressive streaks!</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                            <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                                Default Setting
                                <Tooltip title="Organization default. This is what all current and future members will be set to." arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <ToggleSwitch />
                        </Box>
                        <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', marginLeft: '-18px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box>
                                        <img src='/assets/images/newimages/achieveimg.png'></img>
                                    </Box>
                                    <Box sx={{ marginBottom: '6px' }}>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '16px', fontWeight: '700' }}>Efficiency pro</Typography>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '13px', fontWeight: '400' }}>Achieve your daily activity target</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                    <TextField type='text' sx={{
                                        '& .MuiOutlinedInput-input': {
                                            height: '5px',
                                            width: '70px'
                                        }
                                    }} />
                                    <Typography>%</Typography>
                                    <Button variant="contained" sx={{ textTransform: 'capitalize', borderRadius: '40px', background: '#0076FE', color: '#fff', padding: '7px 20px' }}>Apply to all </Button>
                                </Box>
                            </Box>

                        </Box>
                            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                        <Data />
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="complete">
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                    Productivity cham
                                    <Tooltip title="Achievement badges are sent to members via email and appear on their dashboard." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Earn this badge each week by completing your to-do list. Keep winning it to build an impressive streak!</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                            <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                                Default Setting
                                <Tooltip title="Organization default. This is what all current and future members will be set to." arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <ToggleSwitch />
                        </Box>
                        <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', marginLeft: '-18px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' , flexWrap: 'wrap' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box>
                                        <img src='/assets/images/newimages/achieve.png'></img>
                                    </Box>
                                    <Box sx={{ marginBottom: '6px' }}>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '16px', fontWeight: '700' }}>Efficiency pro</Typography>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '13px', fontWeight: '400' }}>Achieve your daily activity target</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                    <TextField type='text' sx={{
                                        '& .MuiOutlinedInput-input': {
                                            height: '5px',
                                            width: '70px'
                                        }
                                    }} />
                                    <Typography>to-dos</Typography>
                                    <Button variant="contained" sx={{ textTransform: 'capitalize', borderRadius: '40px', background: '#0076FE', color: '#fff', padding: '7px 20px' }}>Apply to all </Button>
                                </Box>
                            </Box>

                        </Box>
                       <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                        <ProductivityData />
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="timetabclick">
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                    Time hero
                                    <Tooltip title="Achievement badges are sent to members via email and appear on their dashboard." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Earn this badge daily by hitting your activity target. Keep the streak alive by achieving it multiple days in a row!</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                             <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                                Default Setting
                                <Tooltip title="Organization default. This is what all current and future members will be set to." arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <ToggleSwitch />
                        </Box>
                        <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', marginLeft: '-18px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'  , flexWrap: 'wrap'}}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box>
                                        <img src='/assets/images/newimages/achhero.png'></img>
                                    </Box>
                                    <Box sx={{ marginBottom: '6px' }}>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '16px', fontWeight: '700' }}>Time hero</Typography>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '13px', fontWeight: '400' }}>Achieve your weekly work hours target</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                    <TextField type='text' sx={{
                                        '& .MuiOutlinedInput-input': {
                                            height: '5px',
                                            width: '70px'
                                        }
                                    }} />
                                    <Typography>Hours</Typography>
                                    <Button variant="contained" sx={{ textTransform: 'capitalize', borderRadius: '40px', background: '#0076FE', color: '#fff', padding: '7px 20px' }}>Apply to all </Button>
                                </Box>
                            </Box>

                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                        <TimeData />
                    </Box>
                </CustomTabPanel>
            </Box>
        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box p={2}>{children}</Box>;
};


export default AchievementPage
